<script lang="ts" setup>
const products = useState<{
    products: ProductBox[];
    categorySlug: string;
}>('menuProducts')
</script>
<template>
  <div class="position-relative">
    <Tracker
      :data="{
        position: 'Hlavne menu'
      }"
    >
      <ProductBox
        v-for="(product, index) in products?.products"
        :key="`mtp-${index}`"
        :item="product"
        :class="[{ 'mb-2': index < products.products.length - 1 }, 'box-shadow-1']"
        padding="p-4"
        heading-size="zeta"
        text-size="fs-smaller"
        heading-level="h3"
      />
    </Tracker>
  </div>
</template>
